module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-01-b936c376fe07d247ef0ee909aabe7696.jpg";